import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface SetWebhookStatusInput {
  id: string;
  // 'failed' is system-set, not user-settable — only active/paused.
  status: 'active' | 'paused';
}

export const useUpdateWebhookStatusTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.webhook.setStatus.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.webhook.list.queryKey(),
        });
      },
    }),
  });

  return {
    setStatus: async (input: SetWebhookStatusInput) =>
      mutation.mutateAsync({ id: input.id, Status: input.status }),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
